import $ from 'jquery';
import { cacheBody } from 'object-cache';
import { Cookie, localStorage } from 'mdlib';
import baseApp from 'lib/baseApp';
import template from './template.twig';

class LocalStorageCookie {
    name = '';
    value = '';

    constructor(name, value) {
        if (typeof name === 'string') {
            this.name = name;
            this.value = value;
        } else {
            const data = name;

            this.name = data.name;
            this.value = data.value;
        }
    }

    set() {
        if (!this.name) {
            return this;
        }

        localStorage.set(this.name, this.value);

        return this;
    }

    get() {
        if (!this.name) {
            return null;
        }

        return localStorage.get(this.name);
    }

    remove() {
        if (!this.name) {
            return this;
        }

        localStorage.remove(this.name);

        return this;
    }
}

class LocalStoragePageCount extends LocalStorageCookie {
    inc() {
        this.value = (this.get() || 0) + 1;

        return this.set();
    }
}

export default class CookieMessage {
    cookie = new Cookie({
        name: 'cookie_message_is_closed',
        value: 'true',
        expires: 307584000,
        path: '/',
        domain: baseApp.cookie.domain,
    });

    storage = new LocalStorageCookie({
        name: 'cookie_message_is_closed',
        value: true,
    });

    pageCount = new LocalStoragePageCount({
        name: 'cookie_message_page_count',
        value: 0,
    });

    constructor(options = {}) {
        this._link = options.link || '/about/rules#confidentiality';
    }

    init() {
        this.pageCount.inc();

        if (!this._canShowed) {
            return;
        }

        this._$message = $(
            template({
                link: this._link,
            })
        );

        cacheBody.$element.append(this._$message);

        this._$message.affix({
            offset: {
                top: 255,
            },
        });
        this._$message.on(
            'click',
            '.js-close-message-about-cookie',
            this._onClickCloseMessage
        );

        this._$message.animate(
            {
                opacity: 1,
            },
            1000
        );
    }

    /**
     * Возвращает флаг, можно ли отобразить сообщение
     *
     * @return {boolean}
     */
    get _canShowed() {
        return (
            !this.cookie.get() &&
            !this.storage.get() &&
            this.pageCount.get() < 3
        );
    }

    /**
     * Обработчик нажатия на кнопку закрытия сообщения
     */
    _onClickCloseMessage = () => {
        this.cookie.set();
        this.storage.set();
        this._$message.animate(
            {
                opacity: 0,
            },
            1000,
            this.destroy
        );
    };

    /**
     * Уничтожение блока с сообщением
     */
    destroy = () => {
        this._$message.detach().remove();
    };
}
